import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Fact from '../Fact/Fact.js';

import { ISummaryBlockConfiguration, ISummaryBlockProps, ISummaryBlockState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SUMMARY_BLOCK_CATEGORY_KEY, SUMMARY_BLOCK_COMPONENT_KEY } from './SummaryBlock.meta.js';

export class SummaryBlock extends ComponentBase<ISummaryBlockProps, ISummaryBlockState, ISummaryBlockConfiguration> {
	categoryKey = SUMMARY_BLOCK_CATEGORY_KEY;
	componentKey = SUMMARY_BLOCK_COMPONENT_KEY;

	constructor(props: ISummaryBlockProps) {
		super(props);
	}
	render() {
		const { className, ...factProps } = this.props;
		return (
			<Wrapper className={className}>
				<Fact {...factProps} />
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(SummaryBlock), SUMMARY_BLOCK_CATEGORY_KEY, SUMMARY_BLOCK_COMPONENT_KEY);
